import ModalBody from 'src/components/Modal/body'
import { Modal } from 'src/components'
import styled from 'styled-components'

export const CustomModal = styled(Modal)`
  --modal-max-width: 40.625rem;
`

CustomModal.displayName = 'CustomPostModal'

export const CustomModalBody = styled(ModalBody)`
  padding-bottom: var(--spacer-4);
`

CustomModalBody.displayName = 'CustomPostModalBody'
